/***********************************************************************************************************************
 * Responsibility - Renders the CTA's for the single proofing card 🐺
 * ******************************************************************
 *
 * @format */

import {ProofingInstructionsDrawer} from '../../modals/proofing_instructions_drawer';
import {PROOF_STATUS_PENDING, TIMELINE_PRESSREADY_DESIGN} from 'frontier-constants';
import {DisapproveSingleModal} from '../../modals/disapprove_single_modal';
import {ApproveSingleModal} from '../../modals/approve_single_modal';
import {Toast, StatusTag} from '@sttark/design-system';
import React, {useState} from 'react';
import {If} from 'frontier-utilities';
import {
    DESIGN_DISAPPROVE_REASON_NEW_ARTWORK,
    DESIGN_STATUS_NOT_REVIEWED,
    DESIGN_STATUS_DISAPPROVED,
    DESIGN_STATUS_APPROVED
} from 'frontier-constants';

export const TableColumnActions = props => {
    const {designOrder, lastDesignToReviewId, handleUndoDesignReview, currentProof} = props;

    const [toast, setToast] = useState({
        isDanger: false,
        isOpen: false,
        message: ''
    });

    const isThisLastDesignToReview = lastDesignToReviewId === designOrder.id;
    const disapproveReasonId = designOrder.disapproveReasonId;
    const disapproveReason = designOrder.proof_status_reason;

    function handleDownload() {
        const prefix = designOrder.pressready_filename ? 'pressready' : 'customer';
        const downloadLink = `/account/designs/download-design?key=${
            designOrder.design[prefix + '_key']
        }&bucket=${process.env.FILESTACK_ARTWORK_CONTAINER}`;

        const link = document.createElement('a');
        link.href = downloadLink; //designOrder.design.pressready_thumb_signed_url;
        link.download = `${designOrder.pressready_filename}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const handleSingleReject = () => {
        setToast({
            message: 'Your artwork has been rejected successfully',
            isDanger: true,
            isOpen: true
        });
    };

    const handleSingleApprove = () => {
        setToast({
            message: 'Your artwork has been approved sucessfully',
            isDanger: false,
            isOpen: true
        });
    };

    const handleCloseToast = () => {
        setToast({
            isDanger: false,
            isOpen: false,
            message: ''
        });
    };

    return (
        <div className="proof-press-ready-56ht--column proof-press-ready-56ht__actions">
            <Toast
                onClose={handleCloseToast}
                danger={toast.isDanger}
                isOpen={toast.isOpen}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">{toast.message}</p>
            </Toast>
            <div className="column-56ht__header d-flex align-items-center justify-content-start">
                <ProofingInstructionsDrawer />
            </div>
            <div className="column-56ht__actions-state">
                <If
                    condition={
                        designOrder.status === DESIGN_STATUS_NOT_REVIEWED ||
                        isThisLastDesignToReview
                    }>
                    <div className="d-flex align-items-center justify-content-start">
                        <ApproveSingleModal
                            onApprove={handleSingleApprove}
                            designOrder={designOrder}>
                            <button className="btn btn--secondary btn-sm d-flex color-accent-primary gap-2 button--success">
                                <i className="fa fa-check" />
                                <b>Approve</b>
                            </button>
                        </ApproveSingleModal>
                        <DisapproveSingleModal
                            onReject={handleSingleReject}
                            designOrder={designOrder}>
                            <button className="btn btn--secondary btn-sm d-flex color-alert-negative gap-2 button--danger">
                                <i className="fa fa-close" />
                                <b>Reject</b>
                            </button>
                        </DisapproveSingleModal>
                    </div>
                </If>
                <If
                    condition={
                        designOrder.status === DESIGN_STATUS_APPROVED && !isThisLastDesignToReview
                    }>
                    <div className="column-56ht__btn-approved-design">
                        <StatusTag type="success" label="Artwork Approved" />
                        <If condition={currentProof.status === PROOF_STATUS_PENDING}>
                            <button
                                onClick={() => handleUndoDesignReview(designOrder.id)}
                                className="color-structure-darker p-0 m-0">
                                <u>Undo approval</u>
                            </button>
                        </If>
                    </div>
                </If>
                <If
                    condition={
                        designOrder.status === DESIGN_STATUS_DISAPPROVED &&
                        !isThisLastDesignToReview
                    }>
                    <div className="column-56ht__btn-approved-design">
                        <StatusTag type="danger" label="Artwork Rejected" />
                        <If condition={currentProof.status === PROOF_STATUS_PENDING}>
                            <button
                                onClick={() => handleUndoDesignReview(designOrder.id)}
                                className="color-structure-darker p-0 m-0">
                                <u>Undo rejection</u>
                            </button>
                        </If>
                    </div>
                </If>
                <div className="column-56ht__actions-design-notes">
                    <If condition={!!disapproveReason}>
                        <div>
                            <h4 className="mt-4">Disapproval Reason</h4>
                            <p>{disapproveReason}</p>
                        </div>
                    </If>
                    <If
                        condition={
                            disapproveReasonId === DESIGN_DISAPPROVE_REASON_NEW_ARTWORK &&
                            designOrder.replacedDesign.length > 0
                        }>
                        <div>
                            <h4 className="mt-4">New artwork</h4>
                            <p>
                                Replaced artwork file with {designOrder.replacedDesign[0]?.filename}
                            </p>
                        </div>
                    </If>
                </div>
            </div>
            <div className="proof_press_ready-56ht__actions-utils d-flex align-items-center justify-content-start pt-4">
                <button className="color-accent-primary d-flex" onClick={handleDownload}>
                    <i className="fa fa-save me-2" />
                    Download Original
                </button>
            </div>
            {/* commenting out until told otherwise by UI/ UX - 03/04/24 */}
            {/*<div className="proof_press_ready-56ht__actions-utils d-flex align-items-center justify-content-start ms-auto me-0">*/}
            {/*    <button className="color-accent-primary">*/}
            {/*        <i className="fa fa-pencil me-2" />*/}
            {/*        <span>Replace Artwork</span>*/}
            {/*    </button>*/}
            {/*</div>*/}
        </div>
    );
};
